export default __webpack_public_path__ + "static/media/undrawGoingUp.971b0d89.svg";